
import Microphone2 from "../../../assets/filled/Microphone2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Microphone2Icon({ className, dataTestid = "Microphone2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Microphone2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
